export default "__VITE_ASSET___3DPiLxt__"